import React, { useMemo } from 'react';
import { useStore } from '../../../../store';
import { useParams } from 'react-router-dom';
import './section0.less';

interface ISection0Props {
  settings: any;
}

const Section0: React.FunctionComponent<ISection0Props> = ({ settings }) => {
  const paragraphsSettings = settings?.paragraphs[0];
  const year = paragraphsSettings?.year;
  const titleLines = useMemo(() => {
    const parts = (settings?.message || '').trim().split(/\s+/);
    if (parts.length <= 1) {
      return { line1: settings?.message || '', line2: '' };
    }
    return {
      line1: parts.slice(0, -1).join(' '),
      line2: parts[parts.length - 1],
    };
  }, [settings?.message]);

  const param = useParams();
  const p_course = param.course || 'student-training';
  const p_topic = param['*'] || 'welcome';
  const { getParagraphState, setParagraphState } = useStore();
  const paragraphs = getParagraphState(p_course, p_topic);
  const onCompleted = () => {
    paragraphs[0].state = 'completed';
    setParagraphState(p_course, p_topic, paragraphs);
  };

  return (
    <div className="topic-section-0">
      <div className="topic-section-0-left">
        <div className="topic-section-0-heading">
          {/* <div className="hero-year" aria-hidden="true">
            {year}
          </div> */}
          <h1 className="hero-title">
            <span>{titleLines.line1}</span>
            {titleLines.line2 ? <span>{titleLines.line2}</span> : null}
          </h1>
        </div>
        <div
          className="description"
          onClick={onCompleted}
          dangerouslySetInnerHTML={{
            __html: paragraphsSettings?.description,
          }}
        />
      </div>
      <div className="topic-section-0-right">
        <div className="right-box">
          <span className="right-welcome">{paragraphsSettings?.welcome}</span>
          <span className="right-title">
            {year}
            {paragraphsSettings?.subTitle}
          </span>
        </div>
      </div>
    </div>
  );
};
export default Section0;
